<!-- ============================================================================
     REGISTROS DUPLICADOS DJ1945
     Interfaz para visualización y corrección de registros duplicados
     ============================================================================ -->

<!-- === REGISTROS DUPLICADOS DJ1945 === -->
<ol class="breadcrumb float-xl-right" *ngIf="!mostrarComoSubcomponente">
	<li class="breadcrumb-item">Inicio / DJ1945 / <a href="javascript:;">Registros Duplicados</a></li>
</ol>

<!-- Breadcrumb cuando es subcomponente -->
<ol class="breadcrumb float-xl-right" *ngIf="mostrarComoSubcomponente">
	<li class="breadcrumb-item">
		<a href="javascript:;" (click)="volverADeclaraciones()">Ver Declaración</a> / Registros Duplicados
	</li>
</ol>

<h1 class="page-header">
	<i class="{{icono}}"></i> {{ titulo }}
	<small>{{ descripcion }}</small>
</h1>

<!-- Enlace discreto para volver a declaraciones -->
<div *ngIf="mostrarComoSubcomponente" class="mb-3">
	<a href="javascript:;" (click)="volverADeclaraciones()" 
	   class="text-muted small text-decoration-none d-inline-flex align-items-center"
	   style="font-size: 0.8rem;">
		<i class="fa fa-arrow-left mr-1" style="font-size: 0.7rem;"></i>
		<span>Volver a Declaración</span>
	</a>
</div>

<panel variant="iatuch" title="{{ titulo }}" (window:resize)="onResize()">
	<!-- Estado de carga -->
	<div *ngIf="isLoading" class="d-flex flex-column align-items-center justify-content-center py-5 my-4">
		<div class="text-center mb-4">
			<h5 class="text-primary mb-2 font-weight-normal">Consultando Registros Duplicados</h5>
			<p class="text-muted mb-0 small">Analizando declaraciones del período...</p>
		</div>
		<div class="d-flex align-items-center justify-content-center">
			<div *ngFor="let dot of [1,2,3]; let i = index"
				class="pulse-dot pulse-dot-{{dot}} bg-primary rounded-circle" [class.mx-2]="i === 1">
			</div>
		</div>
	</div>

	<!-- Contenido principal -->
	<div *ngIf="!isLoading" class="row">
		<div class="col-12">

			<!-- Registros encontrados -->
			<div *ngIf="dj_duplicate_records?.length > 0">

				<!-- Controles superiores -->
				<div class="mb-2 px-3 py-1">
					<!-- Desktop -->
					<div class="d-none d-md-flex justify-content-between align-items-center">
						<div class="bg-white border rounded px-3 py-1 shadow-sm" *ngIf="response_params">
							<div class="d-flex align-items-center">
								<ng-container *ngFor="let info of [
									{icon: 'fa-id-card', bg: 'bg-primary', label: 'RUT', value: response_params.rut},
									{icon: 'fa-calendar-alt', bg: 'bg-info', label: 'Período', value: response_params.periodo},
									{icon: 'fa-building', bg: 'bg-success', label: 'Entidad', value: response_params.entity_code}
								]; let last = last">
									<div class="d-flex align-items-center" [class.mr-3]="!last">
										<div
											class="{{info.bg}} text-white rounded-circle d-flex align-items-center justify-content-center mr-2 info-circle">
											<i class="fas {{info.icon}} font-size-12"></i>
										</div>
										<div>
											<small class="text-muted d-block font-size-10">{{info.label}}</small>
											<strong class="text-dark font-size-13">{{info.value}}</strong>
										</div>
									</div>
									<div *ngIf="!last" class="border-left mx-2 info-divider"></div>
								</ng-container>
							</div>
						</div>
						<button class="btn btn-purple btn-sm" (click)="autocorrection()">
							<i class="fa fa-magic mr-2"></i>
							<span class="d-none d-sm-inline">Autocorrección</span>
							<span class="d-sm-none">Corregir</span>
						</button>
					</div>

					<!-- Móvil -->
					<div class="d-md-none">
						<div class="bg-white border rounded px-2 py-1 shadow-sm mb-2" *ngIf="response_params">
							<div class="row">
								<div class="col-12 mb-2">
									<div class="d-flex align-items-center p-2 bg-light rounded">
										<div
											class="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center mr-2 info-circle-mobile">
											<i class="fas fa-id-card font-size-10"></i>
										</div>
										<div class="flex-grow-1">
											<small class="text-muted d-block font-size-9">RUT</small>
											<strong class="text-dark font-size-12">{{ response_params.rut }}</strong>
										</div>
									</div>
								</div>
								<div class="col-6 mb-2" *ngFor="let item of [
									{icon: 'fa-calendar-alt', bg: 'bg-info', label: 'Período', value: response_params.periodo},
									{icon: 'fa-building', bg: 'bg-success', label: 'Entidad', value: response_params.entity_code}
								]">
									<div class="d-flex align-items-center p-2 bg-light rounded">
										<div
											class="{{item.bg}} text-white rounded-circle d-flex align-items-center justify-content-center mr-2 info-circle-mobile">
											<i class="fas {{item.icon}} font-size-10"></i>
										</div>
										<div class="flex-grow-1">
											<small class="text-muted d-block font-size-9">{{item.label}}</small>
											<strong class="text-dark font-size-12">{{item.value}}</strong>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="text-center">
							<button class="btn btn-purple btn-sm" (click)="autocorrection()">
								<i class="fa fa-magic mr-2"></i>Autocorrección
							</button>
						</div>
					</div>
				</div>

				<!-- Tabla desktop -->
				<div class="d-none d-md-block">
					<div class="border-top border-bottom" style="max-height: 500px; overflow-y: auto;">
						<table class="table table-sm table-hover mb-0">
							<thead
								style="position: sticky; top: 0; border-bottom: 1px; border-color: black; background: rgb(255, 255, 255); z-index: 10;">
								<tr>
									<th class="text-center">#</th>
									<th>RUT</th>
									<th>Nombre</th>
									<th>Tipo</th>
									<th>País</th>
									<th class="text-center">Período</th>
									<th class="text-center">Cantidad</th>
									<th class="text-center">Acción</th>
								</tr>
							</thead>
							<tbody>
								<tr *ngFor="let r of dj_duplicate_records; let i = index; trackBy: trackByRecord">
									<td class="text-center ">{{ i + 1 }}</td>
									<td>{{ r.rut }}</td>
									<td>{{ r.nombre_rut }}</td>
									<td>{{ r.tipo_ing_egr }}</td>
									<td>{{ r.pais }}</td>
									<td class="text-center">{{ r.periodo }}</td>
									<td class="text-center">
										<span class="badge badge-danger">{{ r.count }}</span>
									</td>
									<td class="text-center">
										<button class="btn btn-success btn-xs" (click)="open(modal_opciones, r)"
											ngbTooltip="Ver opciones">
											<i class="fa fa-eye"></i>
										</button>
									</td>
								</tr>
							</tbody>
						</table>
					</div>

					<!-- Footer mostrando el total real -->
					<div class="p-3">
						<small class="text-muted">
							<i class="fa fa-exclamation-triangle text-warning"></i>
							Total de registros duplicados: <strong>{{ dj_duplicate_records?.length || 0 }}</strong>
						</small>
					</div>
				</div>

				<!-- Cards móviles -->
				<div class="d-md-none">
					<div
						class="d-flex align-items-center justify-content-between border-top border-bottom bg-white px-3 py-2">
						<small class="text-dark font-weight-bold">{{ dj_duplicate_records.length }} registros
							duplicados</small>
						<small class="text-muted"><i class="fa fa-exclamation-triangle text-warning"></i></small>
					</div>

					<div [style.height]="maxTableHeight" class="overflow-auto bg-light p-2">
						<div class="row">
							<div *ngFor="let r of dj_duplicate_records; let i = index" class="col-12 col-sm-6 mb-3">
								<div class="mobile-card-item bg-white rounded shadow-sm h-100 border p-3">
									<div class="row align-items-center mb-2">
										<div class="col-3 col-sm-4">
											<span class="badge badge-light text-muted small">#{{ i + 1 }}</span>
										</div>
										<div class="col-6 col-sm-5">
											<div class="font-weight-bold text-primary">{{ r.rut }}</div>
											<small class="text-muted">RUT</small>
										</div>
										<div class="col-3 col-sm-3 text-right">
											<button class="btn btn-success btn-xs" (click)="open(modal_opciones, r)">
												<i class="fa fa-eye"></i>
											</button>
										</div>
									</div>
									<hr class="my-2 border-light">
									<div class="mb-3 p-2 bg-light rounded border-left border-primary">
										<small class="text-muted font-weight-bold d-block mb-1">Nombre</small>
										<div class="font-weight-500 text-dark small">{{ r.nombre_rut }}</div>
									</div>
									<div class="row">
										<div class="col-6 mb-2" *ngFor="let info of [
											{label: 'Tipo', value: r.tipo_ing_egr === 1 ? 'INGRESO' : 'EGRESO'},
											{label: 'País', value: r.pais},
											{label: 'Período', value: r.periodo}
										]">
											<div class="p-2 bg-light rounded border">
												<small class="text-muted d-block mb-1">{{info.label}}</small>
												<div class="font-weight-500 small">{{info.value}}</div>
											</div>
										</div>
										<div class="col-6">
											<div class="p-2 bg-light rounded border text-center">
												<small class="text-muted d-block mb-1">Cantidad</small>
												<span class="badge badge-danger small">{{ r.count }}</span>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="bg-light border-top px-3 py-2">
						<small class="text-muted">
							<i class="fa fa-exclamation-triangle text-warning mr-1"></i>
							Total de registros duplicados: <strong>{{ dj_duplicate_records.length }}</strong>
						</small>
					</div>
				</div>
			</div>

			<!-- Estado vacío -->
			<div *ngIf="dj_duplicate_records?.length === 0" class="text-center py-4 py-md-5">
				<i class="fa fa-check-circle fa-3x text-success mb-3 empty-state-icon"></i>
				<h5 class="text-success mb-2">¡Excelente!</h5>
				<p class="text-muted mb-0">No se encontraron registros duplicados</p>
				<small class="text-muted">Todas las declaraciones están correctas</small>
			</div>
		</div>
	</div>
</panel>

<!-- Modal de opciones -->
<ng-template #modal_opciones let-c="close" let-d="dismiss">
	<div class="modal-header border-bottom">
		<h5 class="modal-title text-dark d-flex align-items-center">
			<i class="fa fa-list-ul text-info mr-2"></i>
			<span class="d-none d-md-inline">Opciones de Agrupación</span>
			<span class="d-md-none">Opciones</span>
		</h5>
		<button type="button" class="close" (click)="d('Cross click')" aria-label="Close">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>

	<div class="modal-body p-0">
		<div class="border-bottom px-3 py-2" *ngIf="opcion_duplicado?.length > 0">
			<span class="text-muted">
				Registro: <strong class="text-dark">{{ opcion_duplicado[0]?.rut }}</strong> - {{
				opcion_duplicado[0]?.nombre }}
			</span>
		</div>

		<!-- Desktop -->
		<div class="d-none d-md-block">
			<div class="table-responsive overflow-auto" style="max-height: 400px;">
				<table class="table table-sm table-hover mb-0">
					<thead class="border-bottom">
						<tr>
							<th *ngFor="let col of [
								{class: 'modal-col-num', text: '#'},
								{class: 'modal-col-origin', text: 'Origen'},
								{class: 'modal-col-dest', text: 'Destino'},
								{class: 'modal-col-relation', text: 'Relación'},
								{class: 'modal-col-entity', text: 'Entidad'},
								{class: 'modal-col-action', text: 'Acción'}
							]" class="py-1 px-1 text-center border-0 font-weight-bold text-dark {{col.class}}">
								{{col.text}}
							</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let od of opcion_duplicado; let i=index" class="table-sm modal-table-cell"
							[class.border-bottom]="i < opcion_duplicado.length - 1">
							<td *ngFor="let cell of [
								{class: 'text-center py-1 px-1 align-middle text-muted modal-table-border modal-col-num', value: i + 1},
								{class: 'text-center py-1 px-1 align-middle modal-table-border modal-col-origin', value: od.origen_ing || '-'},
								{class: 'text-center py-1 px-1 align-middle modal-table-border modal-col-dest', value: od.destino_egr || '-'},
								{class: 'text-center py-1 px-1 align-middle modal-table-border modal-col-relation', value: od.tipo_relacion},
								{class: 'text-center py-1 px-1 align-middle modal-table-border modal-col-entity', value: od.codigo_entidad || '-'}
							]" class="{{cell.class}}">
								{{cell.value}}
							</td>
							<td class="text-center py-1 px-1 align-middle border-0 modal-col-action">
								<button class="btn btn-outline-success btn-xs" (click)="agruparRegistro(od)"
									ngbTooltip="Agrupar registro">
									<i class="fa fa-check mr-1"></i>Agrupar
								</button>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>

		<!-- Móvil -->
		<div class="d-md-none">
			<div style="max-height: 400px; overflow-y: auto;" class="p-3">
				<div *ngFor="let od of opcion_duplicado; let i=index" class="border rounded mb-3 p-3">
					<div class="d-flex align-items-center justify-content-between mb-2">
						<small class="text-muted">Opción {{ i + 1 }} de {{ opcion_duplicado?.length }}</small>
						<button class="btn btn-outline-success btn-sm px-3" (click)="agruparRegistro(od)">
							<i class="fa fa-check mr-1"></i> Agrupar
						</button>
					</div>
					<div class="row">
						<div class="col-6 mb-1" *ngFor="let info of [
							{label: 'Origen', value: od.origen_ing || '-'},
							{label: 'Destino', value: od.destino_egr || '-'},
							{label: 'Entidad', value: od.codigo_entidad || '-'}
						]">
							<small class="text-muted">{{info.label}}:</small>
							<span>{{info.value}}</span>
						</div>
						<div class="col-12">
							<small class="text-muted">Relación:</small>
							<span>{{ od.tipo_relacion }}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div class="modal-footer border-top">
		<small class="text-muted mr-auto">{{ opcion_duplicado?.length || 0 }} opciones disponibles</small>
		<button class="btn btn-secondary btn-sm" (click)="d('Cross click')">
			<i class="fa fa-times mr-1"></i> Cerrar
		</button>
	</div>
</ng-template>